import 'core-js/stable'
import { refuseInsecurePage } from '../../shared/https-only.js'

if (typeof window !== 'undefined' && refuseInsecurePage(window.document, window.location)) {

  throw new Error('HTTPS is required')
}
import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import * as BVN from 'bootstrap-vue-next'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ModalHelp from '../../superturbodb_designer/src/components/ModalHelp.vue'
import Axios from 'axios'

const myApi = Axios.create({
  baseURL: `${VUE_APP_MANAGER_SERVER_URL}`,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

library.add(fas)

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import VueCookies from 'vue-cookies'

const app = createApp(App)
app.use(router)
app.use(createBootstrap())
app.use(createPinia())
app.use(VueCookies)
VueCookies.config('7d')

// Register all bootstrap-vue-next components globally
// createBootstrap() only installs plugins (modal controller, toast, etc.)
// but does not register components in v0.24.x
const componentPrefix = /^B[A-Z]/
for (const [name, component] of Object.entries(BVN)) {
  if (componentPrefix.test(name) && typeof component === 'object' && component.setup) {
    app.component(name, component)
  }
}

app.config.globalProperties.$http = myApi
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('modal-help', ModalHelp)

app.mount('#app')
